import React, { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import { Link, useLocation, useNavigate } from "react-router-dom";
import TeacherVideoProgress from "./TeacherVideoProgress";
import nextArrow from "../Assets/Images/Dashboard/next_icon.png";
import TeacherVideo from "./TeacherVideo";
import Loader from "./Loader";
import TeacherTransferIcon from "../Assets/Images/Sidebar/teacher_transfer_icon.svg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SCHOOL_LIST_GET_API, TEACHER_TRANSFER_POST_API } from "./AllApi";
import Select from "react-select";

const TeacherParticularData = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const trainerName = localStorage.getItem("trainer_name");
  const trainerId = location.state?.trainerId || "";
  const school_name = location.state?.school_name || "";
  const referrer = location.state?.referrer || "";
  const principalName = location.state?.principalName || "";
  const school_id = location.state?.school_id || "";
  const dietDetails = location.state?.dietDetails || "";
  console.log("States: ", location.state);

  // console.log("Props: ",trainerName)
  const [userRole, setUserRole] = useState(localStorage.getItem("user_role"));
  const [token, setToken] = useState(localStorage.getItem("authToken"));

  //for teacher transfer
  const [schools, setSchools] = useState([]);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [isClearable, setIsClearable] = useState(true);
  const [isSearchable, setIsSearchable] = useState(true);

  useEffect(() => {
    // Store referrer in localStorage for Sidebar
    localStorage.setItem("referrer", referrer);

    // Clear referrer on unmount
    return () => {
      localStorage.removeItem("referrer");
    };
  }, [referrer]);

  const fetchSchools = async () => {
    setIsLoading(true);

    try {
      const response = await fetch(SCHOOL_LIST_GET_API, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        const options = data.allSchools
          .filter((school) => school.school_name !== school_name) // Exclude current school
          .map((school) => ({
            value: school.school_id,
            label: school.school_name,
          }));
        // console.log("data: ", data);
        setSchools(options);
      } else {
        console.error("Failed to fetch schools");
      }
    } catch (err) {
      console.error("Error fetching schools:", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  // useEffect(() => {
  //   const timeout = setTimeout(() => {
  //     setIsLoading(false);
  //   }, 2000);

  //   return () => clearTimeout(timeout);
  // }, []);

  const handleSchoolChange = (selectedOption) => {
    setSelectedSchool(selectedOption);
    // Trigger API calls or data updates based on the selected school
    // console.log("Selected School:", selectedOption);
  };

  // Handle transfer teacher action
  const handleTransfer = async () => {
    if (!selectedSchool) {
      toast.warn("Select at least one School", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      // alert("Please select a school before proceeding.");
      return;
    }

    try {
      const payload = {
        trainer_id: trainerId, // Trainer ID from location.state
        school_id: selectedSchool.value, // Selected school ID
      };
      const response = await fetch(TEACHER_TRANSFER_POST_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Teacher transferred successfully:", result);
        toast.success("Teacher Transferred Successfully", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        setTimeout(() => {
          navigate("/teachers");
          window.location.reload();
        }, 3000);
      } else {
        console.error("Failed to transfer teacher");
        toast.error("Something went wrong", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    } catch (err) {
      console.error("Error transferring teacher:", err);
      toast.error("Something went wrong", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      // window.location.reload();
    }
  };

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          <div className="container mt-5">
            <div className="row">
              <div className="col-lg-8">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <Link
                      // to={referrer}
                      to={
                        referrer === "/principal"
                          ? "/school-dashboard"
                          : referrer === "/diet"
                          ? "/schoolTrainersList"
                          : referrer
                      }
                      className="prevPage"
                      state={{
                        school_id: school_id ? school_id : null,
                        principalName: principalName ? principalName : null,
                        referrer: referrer ? referrer : null,
                        dietDetails: dietDetails ? dietDetails : null,
                      }}
                    >
                      {/* Teacher List */}
                      {(() => {
                        switch (referrer) {
                          case "/dashboard":
                            return "Dashboard";
                          case "/school-dashboard":
                            return "School Dashboard";
                          case "/teachers":
                            return "Teacher List";
                          case "/principal":
                            return "Principal";
                          case "/diet":
                            return "DIET";
                          default:
                            return "Back";
                        }
                      })()}
                    </Link>
                    <img
                      src={nextArrow}
                      alt="nextArrow"
                      height={40}
                      className="mt-1"
                    />
                    <p className="currentPage">{trainerName}</p>
                  </ol>
                </nav>
              </div>

              <div className="col-lg-4">
                {userRole === "Principal" && (
                  <div className="d-flex mt-3">
                    <button
                      className="btn btn-secondary"
                      data-bs-toggle="modal"
                      data-bs-target="#teacherTransferModal"
                    >
                      <img
                        src={TeacherTransferIcon}
                        style={{
                          // width: "24px",
                          // height: "24px",
                          marginRight: "13px",
                        }}
                        alt="TeacherTransferIcon"
                      />
                      Transfer
                    </button>
                  </div>
                )}
              </div>
            </div>

            <TeacherVideoProgress trainer_id={trainerId} />
            <TeacherVideo trainerId={trainerId} />
          </div>
        </div>
      )}
      {/* Modal */}
      <div
        className="modal fade "
        id="teacherTransferModal"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        onHide={() => setSelectedSchool(null)}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ width: "auto" }}>
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <p className="logoutTitle mb-0">Tranfer Teacher</p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setSelectedSchool(null)}
              ></button>
            </div>
            {/* Changes */}
            <div className="modal-body">
              <p className="logoutMsg">
                Please select a school to transfer the teacher:
              </p>
              <Select
                options={schools}
                value={selectedSchool}
                onChange={handleSchoolChange}
                isClearable={isClearable}
                isSearchable={isSearchable}
                placeholder="Select a school"
              />
            </div>
            {/* Actions */}
            <div className="row mt-3 mb-3">
              <div className="col text-center">
                <button
                  className="btn logout_yes_btn w-100 text-center"
                  data-bs-target="#confirmTransferModal"
                  data-bs-toggle="modal"
                  data-bs-dismiss="modal"
                  disabled={!selectedSchool}
                >
                  Transfer
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Confirmation Modal */}
      <div
        className="modal fade"
        id="confirmTransferModal"
        tabIndex="-1"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="confirmModalLabel"
        aria-hidden="true"
        onHide={() => setSelectedSchool(null)}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ width: "auto" }}>
            <div className="modal-header" style={{ borderBottom: "none" }}>
              <p className="logoutTitle mb-0">Confirm Transfer</p>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setSelectedSchool(null)}
              ></button>
            </div>

            <div className="modal-body">
              <p className="logoutMsg ms-3">
                Are you sure you want to transfer{" "}
                <strong>{trainerName ? trainerName : "the teacher"}</strong> to{" "}
                <strong>
                  {selectedSchool?.label || "the selected school"}
                </strong>
                ?
              </p>
            </div>

            {/* Actions */}
            <div className="row mt-3 mb-3">
              <div className="col-lg-6 col-sm-12 col-md-6 text-center">
                <button
                  className="btn logout_yes_btn w-100 text-center"
                  onClick={handleTransfer}
                >
                  Yes
                </button>
              </div>
              <div className="col-lg-6 col-sm-12 col-md-6 text-center">
                <button
                  className="btn logout_no_btn w-100 text-center"
                  data-bs-dismiss="modal"
                  onClick={() => setSelectedSchool(null)}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherParticularData;
